import { render, staticRenderFns } from "./TemperatureCard.vue?vue&type=template&id=20e762c9&scoped=true"
import script from "./TemperatureCard.vue?vue&type=script&lang=ts"
export * from "./TemperatureCard.vue?vue&type=script&lang=ts"
import style0 from "./TemperatureCard.vue?vue&type=style&index=0&id=20e762c9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e762c9",
  null
  
)

export default component.exports